export const Status = Object.freeze({
  ERROR: 'error',
  CREATE_USER: 'CREATE_USER_ERROR',
})

export const parseNombre = (nombreCompleto = '') => {
  // limpiar espacios extra
  const value = nombreCompleto.trim()

  let firstName = ''
  let lastName = ''

  if (value.includes(',')) {
    // formato: "Apellido, Nombre ..."
    const [apellido, nombres] = value.split(',')

    lastName = apellido.trim()
    firstName = nombres?.trim().split(/\s+/)[0] ?? ''
  } else {
    // formato: "Nombre Apellido"
    const parts = value.split(/\s+/)

    firstName = parts[0] ?? ''
    lastName = parts[1] ?? ''
  }

  return { firstName, lastName }
}
